import './assets/styles/main.scss';
import PatientsRoutes from './routes';

export default PatientsRoutes;
